/* PDP gallery prev/next arrows. Each arrow simply "clicks" the neighbouring
   thumbnail button: media-gallery.js's own thumbnail wiring then runs
   setActiveMedia, which switches the is-active slide on desktop AND scrolls
   the snap list on mobile — one code path for both layouts, no duplicated
   slider math. Delegated on document so it survives any section re-render. */
(() => {
  if (window.__bitcoGalleryNavBound) return;
  window.__bitcoGalleryNavBound = true;

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-bitco-gallery-prev], [data-bitco-gallery-next]');
    if (!arrow) return;
    const gallery = arrow.closest('media-gallery');
    if (!gallery) return;
    const thumbs = Array.from(gallery.querySelectorAll('.bitco-gallery__thumb'));
    if (thumbs.length < 2) return;

    const current = Math.max(
      0,
      thumbs.findIndex((thumb) => thumb.getAttribute('aria-current') === 'true')
    );
    const delta = arrow.hasAttribute('data-bitco-gallery-prev') ? -1 : 1;
    const target = (current + delta + thumbs.length) % thumbs.length;
    thumbs[target].click();
  });
})();
